import { joinPathsStringUtil } from 'packages/src'
import { getByQueryPathSuffixReduxUtil } from 'modules/redux/utils/getByQueryPathSuffix/index.js'

export default function getByQueryPathReduxUtil (path, query) {
  if (!query) {
    return joinPathsStringUtil(path, 'all')
  }

  // e.g. exercises.byQuery.abs
  return joinPathsStringUtil(
    path,
    getByQueryPathSuffixReduxUtil(query)
  )
}
